import { playbackSteps } from '@trips/shared/playback';
import type { Item } from '@trips/shared/schema';
import { lazy, Suspense, useMemo } from 'react';
import { selectPlaceLookup } from '../../data/selectors';
import { useStore } from '../../data/store';
import { EmptyState } from '../../ui/EmptyState';

// The map engine loads only when a map is opened.
const MapPlayback = lazy(() => import('../map/MapPlayback'));

/** A trip played back on the map: flights, drives, stays and any cruise. */
export function TripMap({ items }: { items: Item[] }) {
  const places = useStore(selectPlaceLookup);
  const steps = useMemo(() => playbackSteps(items, places), [items, places]);
  if (!steps.length)
    return (
      <EmptyState icon="map-trifold" title="Nothing to map yet">
        <p>Add flights or stays with addresses and they play back here.</p>
      </EmptyState>
    );
  return (
    <Suspense fallback={<div style={{ height: 'min(62vh, 560px)' }} />}>
      <MapPlayback steps={steps} />
    </Suspense>
  );
}
